// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lCXp","col":"styles_col__2vASV"};